import { PropsWithChildren } from 'react'
import { ExitButton } from './ExitButton'
import { Flex } from '@workwhile/ui'

/**
 * HeaderBar component that includes an Exit button at the end
 * @param props
 * @constructor
 */
export const HeaderBar = (props: PropsWithChildren) => {
  return (
    <Flex
      position={'sticky'}
      justifyContent={'flex-end'}
      alignItems={'center'}
      backgroundColor={'white'}
      zIndex={2}
      top={'var(--page-sticky-top, 0px)'}
    >
      {props.children}
      <ExitButton />
    </Flex>
  )
}
